import Slider from "react-slick";
import { FeatureFocusTypes } from "../../models/news-articles/regulatory-focus/feature-focus-model";
import { ForAuthorsTypes } from "../../models/news-articles/regulatory-focus/for-authors-model";
import { LatestFeaturesTypes } from "../../models/news-articles/regulatory-focus/latest-features-model";
import { RFQuarterTypes } from "../../models/news-articles/regulatory-focus/rf-quarterly-model";
import NewsArticleAuthorsCards from "./article/news-article-authors-card";
import NewsArticleFeatureCards from "./article/news-article-feature-card";

var settings = {
  dots: true,
  infinite: true,
  speed: 2000,
  arrows: false,
  slidesToShow: 4,
  slidesToScroll: 1,
  initialSlide: 0,
  autoplay: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: true,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
      },
    },
  ],
};

type featuresType = {
  featureFocusData: FeatureFocusTypes[];
  ForAuthorsData: ForAuthorsTypes[];
  LatestFeaturesData: LatestFeaturesTypes[];
  RFQuarterData: RFQuarterTypes[];
};

type NewsAndArticleSliderTypes = {
  cardMainTitle: string;
  cardMainHeading: string;
  cardSlidersec: string;
  cardSecTitle: string;
  cardSecSubTitle: string;
  cardSecContent: string;
  cardSecInfo: string;
  features: featuresType;
};
const NewsArticleSlider = (props: NewsAndArticleSliderTypes) => {
  return (
    <div className={props.cardMainTitle} id="features">
      <div className="row">
        <div className="col-sm-12">
          <h2>{props.cardMainHeading}</h2>
        </div>
        <div className="col-sm-12">
            <div className={`${props.cardSlidersec} `}>
              <Slider {...settings}>
                {props.features?.featureFocusData &&
                  props.features?.featureFocusData[0]?.result?.map((item, index) => {
                    return (
                      <NewsArticleFeatureCards
                        article={item}
                        key={index}
                        cardSecTitle={props.cardSecTitle}
                        cardSecSubTitle={props.cardSecSubTitle}
                        cardSecContent={props.cardSecContent}
                        cardSecInfo={props.cardSecInfo}
                      />
                    );
                  })}
                {props.features?.LatestFeaturesData &&
                  props.features?.LatestFeaturesData[0]?.result?.map((item, index) => {
                    return (
                      <NewsArticleFeatureCards
                        article={item}
                        key={index}
                        cardSecTitle={props.cardSecTitle}
                        cardSecSubTitle={props.cardSecSubTitle}
                        cardSecContent={props.cardSecContent}
                        cardSecInfo={props.cardSecInfo}
                      />
                    );
                  })}
                {props.features?.RFQuarterData &&
                  props.features?.RFQuarterData[0]?.result?.map((item, index) => {
                    return (
                      <NewsArticleFeatureCards
                        article={item}
                        key={index}
                        cardSecTitle={props.cardSecTitle}
                        cardSecSubTitle={props.cardSecSubTitle}
                        cardSecContent={props.cardSecContent}
                        cardSecInfo={props.cardSecInfo}
                      />
                    );
                  })}
                {props.features?.ForAuthorsData &&
                  props.features?.ForAuthorsData[0]?.result?.map((item, index) => {
                    return (
                      <NewsArticleAuthorsCards
                        article={item}
                        key={index}
                        cardSecTitle={props.cardSecTitle}
                        cardSecSubTitle={props.cardSecSubTitle}
                        cardSecContent={props.cardSecContent}
                        cardSecInfo={props.cardSecInfo}
                      />
                    );
                  })}
              </Slider>
            </div>
          </div>
      </div>
    </div>
  );
};

export default NewsArticleSlider;
